import PriceConceptsBreakdown from './PriceConceptsBreakdown.styled';

export default PriceConceptsBreakdown;
